<template>
  <v-overlay
    :value="this.$appMng.isSessionExpired"
    z-index="99999999"
  >
    <v-card
      light
    >
      <v-card-text>
        <p class="body-1 font-weight-regular">{{ this.$appMng.isSessionExpired.message }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          outlined
          @click="redirectToLogin"
        >
          Ir para o login
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-overlay>
</template>

<script>
  import {mapGetters} from "vuex"
  import {GET_USER_DATA} from "../../../store/modules/user"

  export default {
    name: "SessionExpired",
    methods: {
      redirectToLogin() {
        let loginHint = ""
        if (this.getUserData && this.getUserData["strEmail"]) {
          loginHint = this.getUserData["strEmail"]
        }
        this.$router.replace({
          path: "/login",
          query: {
            redirect: this.$route.fullPath,
            login_hint: loginHint,
          },
        })
      },
    },
    computed: {
      ...mapGetters({
        getUserData: GET_USER_DATA,
      }),
    }
  }
</script>

<style scoped>

</style>
